import React, { useRef, useEffect, useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { layout, tailLayout } from './constant';
import ApiServices from '~services';
import { Selection } from '~components';

const GaraForm = ({ fields, isNew, id, reload, onChange, setLoading, dataSelected }) => {
  const inputRef = useRef(null);
  const [companies, setCompanies] = useState([]);

  const getCompanies = async (query = '') => {
    const newQuery = {
      Columns: {
        name: query,
      },
    };
    try {
      const res = await ApiServices.getCompanies(query ? newQuery : null);
      if (res?.data?.data) {
        setCompanies(res?.data?.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getCompanies();
  }, []);

  const onCompareWithApi = (value, cb) => {
    if (inputRef.current) {
      clearTimeout(inputRef.current);
      cb();
    }
    inputRef.current = setTimeout(async () => {
      try {
        const { data } = await ApiServices.existsCodeGara(null, value);
        const isUsed = data;
        cb(isUsed);
      } catch (error) {
        console.error(error);
      }
    }, 1000);
  };

  const checkExistsCode = async (_, value) => {
    if (value.length > 2) {
      const ind = fields.findIndex((item) => {
        return item.name[0] === 'code';
      });
      if (isNew === false && value !== fields[ind].value) {
        try {
          const waitMe = () =>
            new Promise((resolve, reject) => {
              onCompareWithApi(value, (isUsed) => {
                if (typeof isUsed !== 'undefined') {
                  if (isUsed) reject();
                  resolve();
                }
              });
            });
          await waitMe();
        } catch (error) {
          return Promise.reject(new Error('Mã Gara này đã tạo rồi !!!'));
        }
      }

      if (isNew === true) {
        try {
          const waitMe = () =>
            new Promise((resolve, reject) => {
              onCompareWithApi(value, (isUsed) => {
                if (typeof isUsed !== 'undefined') {
                  if (isUsed) reject();
                  resolve();
                }
              });
            });
          await waitMe();
        } catch (error) {
          return Promise.reject(new Error('Mã Gara này đã tạo rồi !!!'));
        }
      }
    }
  };

  const createdGara = async (data) => {
    try {
      const res = await ApiServices.createGara(data);
      if (res.data) {
        message.success('Thêm mới Gara thành công');
        return reload();
      } else {
        message.error('Thêm mới Gara thất baị, vui lòng kiểm tra lại thông tin');
      }
    } catch (err) {
      message.error('Thêm mới Gara thất baị, vui lòng kiểm tra lại thông tin');
      console.error(err);
    }
  };
  const updateGara = async (data) => {
    data.id = id;
    try {
      const res = await ApiServices.updateGara(id, data);
      if (res.data) {
        message.success('Cập nhật Gara thành công');
        return reload();
      } else {
        message.error('Cập nhật Gara thất baị, vui lòng kiểm tra lại thông tin');
      }
    } catch (err) {
      message.error('Cập nhật Gara thất baị, vui lòng kiểm tra lại thông tin');
      console.error(err);
    }
  };
  const onSubmitForm = async (value) => {
    if (isNew) {
      setLoading(true);
      await createdGara(value);
      setLoading(false);
      return;
    }
    setLoading(true);
    await updateGara(value);
    setLoading(false);
  };

  return (
    <Form
      {...layout}
      name='global_state'
      onFinish={onSubmitForm}
      fields={fields}
      onFieldsChange={(_, allFields) => {
        onChange(allFields);
      }}
    >
      <Form.Item
        // {...itemLayout}
        style={{ marginTop: '10px' }}
        name='code'
        label='Mã Gara'
        rules={[
          {
            required: true,
            message: 'Bạn phải nhập Mã Gara',
          },
          {
            validator: checkExistsCode,
          },
          {
            type: 'string',
            min: 3,
            message: 'Bạn phải nhập ít nhất 3 ký tự',
          },
        ]}
      >
        <Input placeholder='Mã Gara' />
      </Form.Item>
      <Form.Item
        style={{ marginTop: '10px' }}
        name='name'
        label='Tên Gara'
        rules={[
          {
            required: true,
            message: 'Bạn phải nhập tên Gara',
          },
        ]}
      >
        <Input placeholder='Tên Gara' />
      </Form.Item>
      <Form.Item name='phone' label='Số Điện thoại'>
        <Input placeholder='Số Điện thoại' />
      </Form.Item>
      <Form.Item
        name='address'
        label='Địa Chỉ'
        rules={[
          {
            required: true,
            message: 'Bạn phải nhập Địa chỉ Gara',
          },
        ]}
      >
        <Input.TextArea placeholder='Địa Chỉ' />
      </Form.Item>
      <Form.Item name='fax' label='Fax'>
        <Input placeholder='Fax' />
      </Form.Item>
      <Form.Item name='contactPerson' label='Người Liên Hệ'>
        <Input placeholder='Người Liên Hệ' />
      </Form.Item>
      <Form.Item
        name='companyId'
        label='Công Ty'
        rules={[
          {
            required: true,
            message: 'Bạn phải chọn Công Ty',
          },
        ]}
      >
        <Selection
          labelDefault={dataSelected?.companyName || ''}
          data={companies}
          placeholder='Bạn phải chọn Công Ty'
          fieldValue='name'
          onSearch={getCompanies}
        />
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Button type='primary' htmlType='submit'>
          {isNew ? 'Thêm Mới' : 'Cập nhật'}
        </Button>
      </Form.Item>
    </Form>
  );
};

export { GaraForm };
